import React from "react";
const DashboardChildren =()=>{
    return<h1>DashboardChildren</h1>
}
export default DashboardChildren;